import React, { useState } from "react";
import HeaderComponent from "../Header/header.component";
import FooterComponent from "../Footer/footer.component";
import { Link, useNavigate } from "react-router-dom";
import {
  FiUser,
  FiShoppingBag,
  FiHeart,
  FiMapPin,
  FiCreditCard,
  FiLogOut,
  FiFile,
  FiPackage,
} from "react-icons/fi";
import AddressComponent from "../../components/organism/address/address.component";
import PersonalInfoComponent from "../../components/organism/account/personal-info.component";
import BillingDetailsComponent from "../../components/organism/account/billing-details.component";
import ModalComponent from "../../components/atoms/modal/modal.component";
import MyOrderComponent from "../../components/organism/account/my-orders.component";

const AccountTemplate = ({ templateData, templateEvent }) => {
  const {
    activeTab,
    user,
    userDetails,
    showLogout,
    orders,
  } = templateData;
  const {
    handleLogout,
    setActiveTab,
    handleConfirmLogout,
    handleClickLogout,
  } = templateEvent;

  const menuItems = [
    { id: "profile", icon: <FiUser />, label: "Profile" },
    { id: "orders", icon: <FiShoppingBag />, label: "Orders" },
    { id: "invoices", icon: <FiFile />, label: "Invoices" },
    { id: "payments", icon: <FiCreditCard />, label: "Payments" },
  ];

  // console.log({shipping});

  const navBtn = (active) => ({
    display: "flex",
    alignItems: "center",
    gap: 10,
    textAlign: "left",
    border: 0,
    background: active ? "var(--brand-violet-50)" : "transparent",
    color: active ? "var(--brand-violet)" : "var(--fg-2)",
    borderRadius: "var(--radius-md)",
    padding: "10px 14px",
    cursor: "pointer",
    font: "var(--fw-semibold) var(--t-body1) var(--font-ui)",
  });

  return (
    <>
      <div className="ds-container">
        <div className="ds-page-head">
          <h1>My account</h1>
        </div>
        <div className="ds-grid-account" style={{ paddingBottom: 56 }}>
          {/* Sidebar */}
          <aside className="ds-panel ds-panel-p">
            <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "6px 6px 16px" }}>
              <span
                style={{
                  width: 48, height: 48, borderRadius: "50%", background: "var(--brand-violet)",
                  color: "#fff", display: "flex", alignItems: "center", justifyContent: "center",
                  fontWeight: 700, fontSize: 18, flex: "0 0 auto",
                }}
              >
                {user?.name?.charAt(0)?.toUpperCase()}
              </span>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontWeight: 600 }}>{user?.name}</div>
                <div className="ds-muted" title={user?.email} style={{ fontSize: 12, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{user?.email}</div>
              </div>
            </div>
            <nav style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  style={navBtn(activeTab === item.id || (item.id === "profile" && activeTab === "addresses"))}
                  onClick={() => setActiveTab(item.id)}
                >
                  {item.icon} {item.label}
                </button>
              ))}
              <button style={{ ...navBtn(false), color: "var(--danger)" }} onClick={handleClickLogout}>
                <FiLogOut /> Logout
              </button>
            </nav>
          </aside>

          {/* Content */}
          <section>
            {(activeTab === "profile" || activeTab === "addresses") && (
              <div className="ds-stack">
                <div className="ds-panel ds-panel-p">
                  <h3 className="ds-mb-l">Personal Information</h3>
                  <PersonalInfoComponent user={user} />
                </div>
                <div className="ds-panel ds-panel-p" id="add-address">
                  <h3 className="ds-mb-l">Addresses</h3>
                  <BillingDetailsComponent />
                </div>
              </div>
            )}
            {activeTab === "orders" && (
              <div>
                <MyOrderComponent />
              </div>
            )}
          </section>
        </div>
      </div>
      <ModalComponent
        open={showLogout}
        title={"Logout !"}
        message={"Are you sure to logout?"}
        primaryAction={handleConfirmLogout}
        secondaryAction={handleClickLogout}
        primaryText={"Logout"}
        secondaryText={"Cancel"}
      />
      {/* <FooterComponent /> */}
    </>
  );
};

export default AccountTemplate;
